// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"90a1f7ab","236":"19e52875","358":"13a53808","518":"4dfe6fd8","788":"ec3abe16","906":"887d5d40","922":"e235e450"}[chunkId] + ".chunk.js";
};